export default __webpack_public_path__ + "static/media/gith.cfaf2e78.png";